import { useEffect, useState } from 'react';
import { invoke, view } from '@forge/bridge';

import { FieldsOnRequest, RtField } from '../api/servicedeskApi';
import { Field } from '../interfaces';
import { JIRA_EXPRESSION_CF_TYPE, MULTILEVEL_CF_TYPE, REGEX_CF_TYPE } from '../shared_models/constants';

export const useProprietaryFieldsOnRequests = () => {
    const [fieldsOnRequests, setFieldsOnRequest] = useState<RtField[]>([]);
    const [existsAtLeastOne, setExistsAtLeastOne] = useState<boolean>(false);
    const SUPPORTED_CF_TYPES = [MULTILEVEL_CF_TYPE, REGEX_CF_TYPE, JIRA_EXPRESSION_CF_TYPE];

    const getFieldsValues = (fields: Field[], fieldsOnRequest: FieldsOnRequest) => {
        const fieldsIds = fields.filter(f => SUPPORTED_CF_TYPES.some(type => f.schema?.custom?.endsWith(type))).map(f => f.id);
        return fieldsOnRequest.requestTypeFields.filter(item => fieldsIds.includes(item.fieldId));
    };

    const fetchFields = async () => {
        const context = await view.getContext();
        const [fields, requestTypesFields] = await Promise.all([
            invoke<Field[]>('get-fields'),
            invoke<FieldsOnRequest>('get-request-type-fields', {
                serviceDeskId: context.extension?.portal?.id as string,
                requestTypeId: context.extension?.request?.typeId,
            }),
        ]);
        const rtFields = getFieldsValues(fields, requestTypesFields);
        setFieldsOnRequest(rtFields);
        setExistsAtLeastOne(rtFields.length > 0);
    };

    useEffect(() => {
        void fetchFields();
    }, []);

    return [fieldsOnRequests, existsAtLeastOne] as [RtField[], boolean];
};
